import InputLabel from "@material-ui/core/InputLabel";
export default InputLabel;